export default "__VITE_ASSET__CWHtwpl6__"